import styled from "styled-components";
import { Modal } from "reactstrap";
import { ReactComponent as MainLogoABC } from "../../../abc/src/data/icon-component/abc-logo.svg";
import { ReactComponent as MainLogoPUB } from "../../../pub/src/data/icon-component/logo.svg";
import { ReactComponent as MainLogoYET } from "../../../yet/src/data/icon-component/logo-mobile.svg";
import { ReactComponent as MainLogoFUN } from "../../../fun/src/data/icon-component/logo.svg";
import { ReactComponent as MainLogoCAC } from "../../../cac/src/data/icon-component/logo.svg";
import { ReactComponent as MainLogoHYC } from "../../../hyc/src/data/icon-component/logo.svg";
import { ReactComponent as MainLogoQBC } from "../../../qbc/src/data/icon-component/logo.svg";
import { isMobile } from "react-device-detect";

export const StyledModal = styled(Modal).attrs({
  className: "modal-dialog modal-lg modal-dialog-centered",
})`
  box-shadow: 0 15px 35px hsla(0, 0%, 0.2);
`;

export const StyledModalBody = styled.div.attrs((props) => ({
  className: `modal-body ${props.position ? "text-center" : ""}`,
}))`
  text-align: ${({ queue }) => (queue ? "center" : "")};
  font-weight: ${({ queue }) => (queue ? "600" : "")};
  font-size: ${({ queue, pause, rollingLimits }) =>
    queue || pause || rollingLimits ? "1.1rem" : ""};
  padding: ${({ riskScore }) => riskScore && isMobile && "1rem 0 1rem 0"};
  h3 {
    color: ${({ theme }) =>
      theme.skin === "abc"
        ? "#0554b3"
        : theme.skin === "pub"
          ? "#9A875D"
          : theme.skin === "yet"
            ? "#07415f"
            : theme.skin === "fun"
              ? "var(--tabletext)"
              : theme.skin === "cac" ||
                  theme.skin === "qbc" ||
                  theme.skin === "bec"
                ? "#1b1b1b"
                : "#4d79ff"};
    font-size: 21px;
    font-weight: 500;
  }
  h2 {
    font-weight: 500;
    color: ${({ theme }) =>
      theme.skin === "abc"
        ? "#0554b3"
        : theme.skin === "pub"
          ? "#9A875D"
          : theme.skin === "yet"
            ? "#07415f"
            : theme.skin === "fun"
              ? "var(--tabletext)"
              : theme.skin === "cac" ||
                  theme.skin === "qbc" ||
                  theme.skin === "bec"
                ? "#1b1b1b"
                : "#4d79ff"};
  }
  ${(props) => {
    if (props.register) {
      return `
      margin: ${
        props.theme.skin === "pub" ||
        props.theme.skin === "cac" ||
        props.theme.skin === "hyc"
          ? "1rem"
          : "1rem !important"
      };
      text-align: center !important;
      `;
    }
  }};
  div {
    font-size: ${({ rollingLimits }) => rollingLimits && "1.1rem"};
    padding: ${({ rollingLimits }) => rollingLimits && "0.5rem"};
  }
`;

export const StyledModalFooter = styled.div.attrs((props) => ({
  className: `modal-footer ${props.position ? "justify-content-center" : ""}`,
}))`
  button {
    font-size: 0.7rem !important;
    background-image: ${({ theme }) =>
      theme.skin !== "qbc" && "none !important"};
    background: ${({ theme }) =>
      theme.skin === "qbc" &&
      "linear-gradient(90deg, rgba(253, 175, 30, 1) 0%, rgba(253, 137, 24, 1) 100%)"};
    color: ${({ colorBtn }) => (colorBtn ? "#1b1b1b" : "")};
    max-width: ${({ realityCheckDialog }) =>
      realityCheckDialog && isMobile ? "100px" : ""};
  }
`;

export const SearchModalBg = styled.div.attrs({
  className: "show",
})`
  opacity: 0;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 90;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.85);
  transition: all 0.4s ease;
  &.show {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const SearchModalContent = styled.div`
  box-sizing: border-box;
  transform: ${({ propsTransform }) =>
    propsTransform ? "translateY(0%)" : "translateY(15%)"};
  width: 80%;
  transition: all 1.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  input::placeholder {
    color: ${({ theme }) => theme.skin === "fun" && "#fff"};
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: ${({ theme }) =>
      theme.skin === "abc" ? "var(--tabletext)" : "var(--acolor)"};
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    box-shadow: 0 0 0px 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
    font-size: 30px;
  }
  &::-internal-autofill-previewed {
    font-size: 30px !important;
  }
  label {
    color: var(--carouseltext);
    letter-spacing: 2px;
  }
  //provider name show/hide
  .list-group-item {
    /* span {
      display: none; 
    } */
  }

  form {
    & > input[type="text"] {
      width: 100%;
      background-color: ${({ theme }) =>
        theme.skin === "abc" || theme.skin === "yet" || theme.skin === "hyc"
          ? "var(--bgColorABC)"
          : theme.skin === "pub"
            ? "#1d1d1d"
            : "var(--bgcolor)"};
      border-color: -internal-light-dark(
        rgb(118, 118, 118),
        rgb(133, 133, 133)
      );
      border-bottom: ${({ theme }) =>
        theme.skin === "abc" || theme.skin === "yet" || theme.skin === "hyc"
          ? "2px solid var(--bgColorABC)"
          : "2px solid var(--bgcolor)"};
      border-top: ${({ theme }) =>
        theme.skin === "abc" || theme.skin === "yet" || theme.skin === "hyc"
          ? "2px solid var(--bgColorABC)"
          : "2px solid var(--bgcolor)"};
      border-left: ${({ theme }) =>
        theme.skin === "abc" || theme.skin === "yet" || theme.skin === "hyc"
          ? "2px solid var(--bgColorABC)"
          : "2px solid var(--bgcolor)"};
      border-right: ${({ theme }) =>
        theme.skin === "abc" || theme.skin === "yet" || theme.skin === "hyc"
          ? "2px solid var(--bgColorABC)"
          : "2px solid var(--bgcolor)"};
      border-radius: ${({ theme }) =>
        theme.skin === "abc" || theme.skin === "yet" || theme.skin === "hyc"
          ? "0.5rem"
          : "3rem"};
      padding: 1rem 2rem;
      color: ${({ theme }) =>
        theme.skin === "fun" ? "#fff" : "var(--tabletext)"};
      /* font-family: "Catamaran", Fallback, sans-serif; */
      font-weight: 800;
      letter-spacing: 2px;
      font-size: 30px;
      resize: vertical;
      margin: 0;
      margin: 10px 0px;

      &:-webkit-autofill::first-line {
        font-size: 30px;
        font-weight: bold;
        // color: green;
      }

      @media (max-width: 768px) {
        font-size: 16px !important;
        &:-webkit-autofill::first-line {
          font-size: 16px;
        }
      }
    }
  }

  @media (min-width: 576px) {
    width: 50%;
  }
  @media (max-width: 768px) {
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
      font-size: 16px;
    }
  }
`;

export const SearchListGroup = styled.div.attrs({
  className: "list-group",
})`
  border-bottom-left-radius: 1rem;

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) =>
      theme.skin === "abc" || theme.skin === "yet"
        ? "var(--bgColorABC)"
        : "var(--bgcolor)"};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) =>
      theme.skin === "fun"
        ? "var(--thumbBG)"
        : theme.skin === "yet"
          ? "var(--scrollbarBG)"
          : ""};
  }

  ${(props) => {
    if (props.theme.skin === "abc") {
      return `
      &::-webkit-scrollbar-thumb {
        background-color: #1f355e;
        border-radius: 0px;
        border: none;
      }   
      `;
    }
  }}
  span {
    display: none;
  }
  /* a {
    height: 1170px;
  } */

  @media (min-width: 576px) {
    span {
      display: inherit;
    }
  }
  @media (max-width: 768px) {
    height: calc(40vh);
  }
`;

export const AlertDanger = styled.div.attrs((props) => ({
  className: props.danger ? "alert alert-danger" : "",
}))``;

export const LookupListItem = styled.div`
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;

export const ModalLogoWrapper = styled.div`
  width: 100%;
  height: 40px;
`;

export const ModalLogoABC = styled(MainLogoABC)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  z-index: 99;
  fill: #ae0005;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-transition: all 0.2s ease;
  top: 2rem;

  @media (max-width: 767px) {
    top: 2rem;
    height: 40px;
  }
`;

export const ModalLogoPUB = styled(MainLogoPUB)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  z-index: 99;
  fill: #ae0005;
  /* cursor: pointer; */
  transition: all 0.2s ease;
  -webkit-transition: all 0.2s ease;
  top: 0rem;

  @media (max-width: 767px) {
    top: 1rem;
    height: 40px;
  }
`;

export const ModalLogoYET = styled(MainLogoYET)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  z-index: 99;
  fill: #fff;
  /* cursor: pointer; */
  transition: all 0.2s ease;
  -webkit-transition: all 0.2s ease;
  top: 2rem;

  @media (max-width: 767px) {
    top: 1rem;
    height: 40px;
  }
`;

export const ModalLogoFUN = styled(MainLogoFUN)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  z-index: 99;
  fill: #fff;
  /* cursor: pointer; */
  transition: all 0.2s ease;
  -webkit-transition: all 0.2s ease;
  top: 2rem;

  @media (max-width: 767px) {
    top: 1rem;
    height: 40px;
  }
`;

export const ModalLogoCAC = styled(MainLogoCAC)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  z-index: 99;
  fill: #fff;
  /* cursor: pointer; */
  transition: all 0.2s ease;
  -webkit-transition: all 0.2s ease;
  top: 2rem;

  @media (max-width: 767px) {
    top: 1rem;
    height: 40px;
  }
`;

export const ModalLogoHYC = styled(MainLogoHYC)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  z-index: 99;
  fill: #fff;
  /* cursor: pointer; */
  transition: all 0.2s ease;
  -webkit-transition: all 0.2s ease;
  top: 2rem;

  #Fill-1,
  #Fill-4,
  #Fill-6,
  #Fill-8 {
    fill: silver;
  }

  @media (max-width: 767px) {
    top: 1rem;
    height: 40px;
  }
`;

export const ModalLogoQBC = styled(MainLogoQBC)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  z-index: 99;
  fill: #fff;
  /* cursor: pointer; */
  transition: all 0.2s ease;
  -webkit-transition: all 0.2s ease;
  top: 2rem;

  /* .st0 {
    fill: #a687d8;
  } */

  @media (max-width: 767px) {
    top: 1rem;
    height: 40px;
  }
`;

export const RegisterCloseButton = styled.div`
  &:after {
    font-size: 20px;
    font-family: "Material Icons";
    content: "close";
    vertical-align: bottom;
  }

  -webkit-transition: all 0.35s ease;
  transition: all 0.35s ease;
  position: absolute;
  width: 40px;
  height: 40px;
  top: 10px;
  right: 5px;
  z-index: 99;
  color: #616060 !important;
  cursor: pointer;
  text-align: center;

  :hover {
    color: #b8b8b8 !important;
  }

  /* @media (max-width: 767px) {
    top: -0.9rem;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    top: -1rem;
  } */
`;

export const LinkWrapper = styled.div`
  a {
    &:hover {
      color: #ae0005 !important;
    }
  }
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  gap: 5px;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme?.colors?.border || "#e9ecef"};
  border-radius: 8px;
  background-color: ${({ theme }) =>
    theme?.colors?.questionBackground || "#ffffff"};

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  p {
    font-style: normal !important;
  }
`;

export const QuestionText = styled.p`
  margin: 0 0 8px 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme?.colors?.text || "#333"};
  word-wrap: break-word;
  hyphens: auto;
`;

export const QuestionInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme?.colors?.border || "#ccc"};
  border-radius: 4px;
  font-size: 14px;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme?.colors?.primary || "#007bff"};
    box-shadow: 0 0 0 2px
      ${({ theme }) => theme?.colors?.primary + "20" || "#007bff20"};
  }

  &::placeholder {
    color: ${({ theme }) => theme?.colors?.placeholder || "#6c757d"};
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  align-items: center;
  margin: auto;

  @media (max-width: 480px) {
    /* flex-direction: column; */
    align-items: flex-start;
    gap: 30px;
  }
`;

export const RadioLabel = styled.label`
  display: flex;
  /* align-items: center; */
  margin: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme?.colors?.text || "#333"};
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme?.colors?.primary || "#007bff"};
  }

  input[type="radio"] {
    margin-top: 3px;
    cursor: pointer;
    transform: scale(1.1);
  }
`;

export const ScoreRadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px 24px;
  width: 100%;
  margin: 0;

  ${RadioLabel} {
    align-items: center;
    gap: 6px;
  }
`;

export const QuestionsWrapper = styled.div`
  margin: 20px 0;
  padding: 15px;
  background-color: var(--questionWrapperBg);
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme?.colors?.border || "#e9ecef"};

  p {
    font-size: 14px;
    color: "#6c757d";
    margin-bottom: 15px;
    font-style: italic;
    text-align: center;
  }

  span {
    color: red;
    font-size: 12px;
    margin-top: 4px;
  }
`;

export const EventDescription = styled.div`
  margin-bottom: 20px;
  padding: 15px;
  background-color: ${({ theme }) => theme?.colors?.info || "#d1ecf1"};
  border: 1px solid ${({ theme }) => theme?.colors?.infoBorder || "#bee5eb"};
  border-radius: 6px;
  color: ${({ theme }) => theme?.colors?.infoText || "#0c5460"};
  font-weight: 500;
  line-height: 1.4;
`;
